module.exports = __webpack_public_path__ + "img/SKLB-Configuracion.547d5590.png";